import {ChangeDetectorRef, Component, DoCheck, OnInit, ViewChild, ViewRef} from '@angular/core';
import {ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {SpinnerVisibilityService} from 'ng-http-loader';
import {MesHttpStatusHandlerService} from 'common-shared';
import {StateService, WebUserModel} from 'web-shared';
import {AuthService} from 'web-shared';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
@Component({
  templateUrl: 'layout.component.html'
})

export class LayoutComponent implements OnInit {
  constructor(private router: Router, private spinner: SpinnerVisibilityService, public stateService: StateService, private mesHttpStatusHandlerService: MesHttpStatusHandlerService, private authService: AuthService, private route: ActivatedRoute, private ref: ChangeDetectorRef, private ngbModalConfig: NgbModalConfig) {
    mesHttpStatusHandlerService.http401.subscribe(value => {
      this.authService.logout();
    });

    const user = this.route.snapshot.data.user as WebUserModel;
    this.stateService.currentUser$.next(user);

    this.ngbModalConfig.animation = false;
  }

  ngOnInit() {
    this.mesHttpStatusHandlerService.cacheExpire$.subscribe(value => {
      setInterval(() => {
        if (!(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      }, 1000);
    });

    this.router.events.subscribe({
      next: event => {
        if (event instanceof NavigationStart) {
          this.spinner.show();
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.spinner.hide();
        }
      }, error: () => {
        this.spinner.hide();
      }
    });
  }
}
